export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-mail-send-line"></i>
            联系我们
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            投稿与合作
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
            欢迎探花大神创作者投稿优质内容，或有合作意向的朋友与我们取得联系。
            探花系列平台期待更多探花精选资源的加入。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-mail-line"></i>
              投稿内容
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-400 text-foreground-700 hover:text-primary-600 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-chat-1-line"></i>
              商务合作
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-400 text-foreground-700 hover:text-primary-600 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-error-warning-line"></i>
              问题反馈
            </a>
          </div>

          <div className="flex items-center justify-center gap-6 text-sm text-foreground-500">
            <div className="flex items-center gap-1.5">
              <i className="ri-time-line text-primary-500"></i>
              <span>每日 10:00-22:00</span>
            </div>
            <div className="w-px h-4 bg-background-300"></div>
            <div className="flex items-center gap-1.5">
              <i className="ri-refresh-line text-primary-500"></i>
              <span>24小时内回复</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}